module.exports = __webpack_public_path__ + "img/ico-linkedin-circle.4a1b5d7e.svg";